WL.registerComponent('gift-spawner', {
    trainPool: { type: WL.Type.Object },
    chestPool: { type: WL.Type.Object },
    horsePool: { type: WL.Type.Object },
    starPool: { type: WL.Type.Object },
    candyCanePool: { type: WL.Type.Object },
    targetParent: { type: WL.Type.Object },
    spawnRate: { type: WL.Type.Float, default: 15 },
}, {
    init() {
        this.spawnerActive = false;
        this.giftsInPool = [];
        this.giftsOutOfPool = [];
    },
    start() {
        window.SW.gameState.stateSubject.subscribe(
            this.handleStateChange.bind(this));
        this.timer = 0;
    },
    startSpawning(giftsToSpawn, spawnRate) {
        // only spawn giftsToSpawn.
        this.spawnRate = spawnRate;        
        this.giftsInPool.length = 0;
        this.giftsInPool.push(...this.trainPool.children.slice(0, giftsToSpawn.filter(g => g === wishes.train).length));
        this.giftsInPool.push(...this.chestPool.children.slice(0, giftsToSpawn.filter(g => g === wishes.chest).length));
        this.giftsInPool.push(...this.horsePool.children.slice(0, giftsToSpawn.filter(g => g === wishes.horse).length));
        this.giftsInPool.push(...this.candyCanePool.children.slice(0, giftsToSpawn.filter(g => g === wishes.candy).length));
        this.giftsInPool.push(...this.starPool.children.slice(0, giftsToSpawn.filter(g => g === wishes.star).length));
        this.spawnerActive = true;
        this.timer = this.spawnRate - 2;
    },
    handleStateChange(state) {
        if (state != State.gameplay) {
            this.spawnerActive = false;
        }
    },
    update(dt) {
        if (!this.spawnerActive) return;
        this.timer += dt;
        if (this.timer > this.spawnRate) {
            this.timer = 0;
            this.spawn();
        }
    },
    spawn() {
        const gift = this.giftsInPool.splice(Math.floor(Math.random() * this.giftsInPool.length), 1)[0];
        if (!gift) {
            // if there's no gift in the pool, just return.
            return;
        }
        gift.resetTranslationRotation();
        this.giftsOutOfPool.push(gift);
        gift.setTranslationWorld([-3.00974, 0.95, -1.73078]);
        const cm = gift.getComponent('conveyor-movement');        
        cm.go();
        cm.pool = this;
    },
    reset() {
        this.timer = 0;      
        this.giftsOutOfPool.forEach(gift => {
            gift.getComponent('conveyor-movement').reset();
        });        
        this.giftsOutOfPool.length = 0;
        this.giftsInPool.length = 0;
        this.spawnerActive = false;
    },
    removeFromPool(gift) {
        let idx = this.giftsOutOfPool.indexOf(gift);
        this.giftsOutOfPool.splice(idx, 1);
        gift.getComponent('conveyor-movement').reset();
    },
    /* Return object to pool */
    despawn(gift) {
        let idx = this.giftsOutOfPool.indexOf(gift);
        this.giftsOutOfPool.splice(idx, 1);
        this.giftsInPool.push(gift);
        gift.getComponent('conveyor-movement').reset();
    }
});
